<template>
    <div class="page-content">
        <div class="page-head">
            <div class="page-head-content">
                <el-form label-position="top" inline>
                    <el-form-item label="类型">
                        <el-select v-model="type">
                            <el-option v-for="item in typeList" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="地区">
                        <el-select v-model="searchForm.area_id" filterable clearable>
                            <el-option value="" label="全部地区"></el-option>
                            <el-option v-for="item in cityList" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-select v-model="searchForm.order_by">
                            <el-option v-for="item in sortList" :key="item.id" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 50px;">
                        <el-button type="primary" @click="handlerSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="card-content">
            <StoryCard :type="currentType" v-for="item in list" :key="item.id" :item="item"></StoryCard>
        </div>
        <div v-if="!finish" class="load-content">上拉加载更多 <i class="el-icon-loading"></i></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import StoryCard from "@/components/StoryCard";

    export default {
        name: "storyList",
        components: {StoryCard},
        data() {
            return {
                typeList: [
                    {id: 1, name: '购物攻略'},
                    {id: 2, name: '景点･温泉'},
                    {id: 3, name: '日本美食'}
                ],
                sortList: [
                    {id: 0, name: '评价降序'},
                    {id: 1, name: '评价升序'},
                    {id: 2, name: '消费降序'},
                    {id: 3, name: '消费升序'}
                ],
                type: 1,
                currentType: 1,
                list: [],
                finish: false,
                searchForm: {
                    page: 1,
                    size: 12,
                    area_id: '',
                    type_id: 0,
                    order_by: 0
                }
            }
        },
        computed: {
            ...mapState(['cityList'])
        },
        created() {
            this.getHotSpring();
            this.$eventBus.$on('onBottom', this.handlerBottom)
        },
        beforeDestroy() {
            this.$eventBus.$off('onBottom', this.handlerBottom)
        },
        methods: {
            async getHotSpring() {
                let [e, data] = await this.$api.getHotSpringApi(this.searchForm);
                if (data.code === 200) {
                    if (this.searchForm.page === 1) {
                        this.list = data.result;
                    } else {
                        this.list = [...this.list, ...data.result];
                    }
                    this.finish = data.result.length < this.searchForm.size
                }
            },
            async getScenery() {
                let [e, data] = await this.$api.getSceneryApi(this.searchForm)
                if (data.code === 200) {
                    if (this.searchForm.page === 1) {
                        this.list = data.result;
                    } else {
                        this.list = [...this.list, ...data.result];
                    }
                    this.finish = data.result.length < this.searchForm.size
                }
            },
            async getCate() {
                let [e, data] = await this.$api.getCateApi(this.searchForm)
                if (data.code === 200) {
                    if (this.searchForm.page === 1) {
                        this.list = data.result;
                    } else {
                        this.list = [...this.list, ...data.result];
                    }
                    this.finish = data.result.length < this.searchForm.size
                }
            },
            getData(){
                if (this.type === 1) {
                    this.getHotSpring()
                } else if (this.type === 2) {
                    this.getScenery();
                } else if (this.type === 3) {
                    this.getCate();
                }
            },
            handlerSearch() {
                this.searchForm.page = 1;
                this.currentType = this.type;
                this.finish = false;
                this.getData();
            },
            handlerBottom() {
                if (this.finish) return;
                this.searchForm.page++;
                this.getData();
            }
        }
    }
</script>

<style scoped lang="less">
    .page-head {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        position: sticky;
        top: 80px;
        left: 0;
        z-index: 10;
        border-bottom: solid 1px #e2e2e2;

        .page-head-content {
            width: 1200px;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
    }
</style>
